import { render, staticRenderFns } from "./ApproveLevel2.vue?vue&type=template&id=d8895208&scoped=true"
import script from "./ApproveLevel2.vue?vue&type=script&lang=js"
export * from "./ApproveLevel2.vue?vue&type=script&lang=js"
import style0 from "./ApproveLevel2.vue?vue&type=style&index=0&id=d8895208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8895208",
  null
  
)

export default component.exports